import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChatWithLinesIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 3.33301C14.1663 3.11211 14.0784 2.90034 13.9222 2.74414C13.7659 2.58796 13.5543 2.5 13.3333 2.5H2.66634C2.44544 2.50009 2.23368 2.58794 2.07747 2.74414C1.92127 2.90034 1.83342 3.11211 1.83333 3.33301V14.126L3.25618 12.7041C3.59991 12.3603 4.06594 12.1671 4.55208 12.167H13.3333C13.5542 12.167 13.766 12.0789 13.9222 11.9229C14.0785 11.7666 14.1663 11.554 14.1663 11.333V3.33301ZM15.1663 11.333C15.1663 11.8192 14.973 12.2861 14.6292 12.6299C14.2854 12.9735 13.8194 13.167 13.3333 13.167H4.55208C4.3311 13.167 4.11945 13.2548 3.96322 13.4111L2.49447 14.8789C2.35837 15.0149 2.18513 15.108 1.99642 15.1455C1.80767 15.183 1.61171 15.1635 1.43392 15.0898C1.25619 15.0162 1.1043 14.8914 0.997396 14.7314C0.890442 14.5714 0.833358 14.3829 0.833333 14.1904V3.33301C0.833419 2.84689 1.0267 2.38085 1.37044 2.03711C1.71418 1.69337 2.18023 1.50009 2.66634 1.5H13.3333C13.8195 1.5 14.2854 1.69339 14.6292 2.03711C14.973 2.38085 15.1663 2.84689 15.1663 3.33301V11.333Z"
      fill="currentColor"
    />
    <path
      d="M10.333 8.16699C10.6092 8.16699 10.833 8.39085 10.833 8.66699C10.833 8.94313 10.6092 9.16699 10.333 9.16699H5C4.72386 9.16699 4.5 8.94313 4.5 8.66699C4.5 8.39085 4.72386 8.16699 5 8.16699H10.333Z"
      fill="currentColor"
    />
    <path
      d="M11.667 5.5C11.943 5.50018 12.167 5.72397 12.167 6C12.167 6.27603 11.943 6.49982 11.667 6.5H5C4.72386 6.5 4.5 6.27614 4.5 6C4.5 5.72386 4.72386 5.5 5 5.5H11.667Z"
      fill="currentColor"
    />
  </svg>
);
